<template>
  <div class="page dark intro">


    <div class="inner">
      <h1>Location</h1>
        
        <p>Located near South Molton on the edge of Exmoor National Park in North Devon, our unique studio, complete with bar and beautiful surroundings, provides a comfortable and relaxed working environment for every musician.</p>
        <p>Check out <a href="https://www.masonsarmsdevon.co.uk/local-info/local_information.php" target="_blank">The Masons Arms</a> website for more local information and accommodation.</p>
    </div>
  </div>
</template>

<script>


export default {
  name: 'intro'
}
</script>

<style scoped lang="scss">
h1{
  color: rgb(244, 167, 194);

}
.intro{
  border-top:1px solid rgba(87, 64, 87, 0.345);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-image: url('../assets/local/twilight.jpg');
  background-size: cover;
  background-position: center bottom; 
  min-height:50vh;
  .inner{
    max-width: 1200px;

    
    // /padding:0 5%;
    padding-top:0.5em;

  }
}
a{
  color:white;
  text-decoration: none;
  font-weight:bold;
  &:hover{
    color:pink;
  }
}

@media only screen and (max-width: 600px) {
  .intro{
     min-height:100vh;
       align-items: flex-start;
       padding:0 2%;
       padding-top:1.5em;
       line-height: 1.5em;
     .inner{
      // background-color: rgba(0,0,0,0.3);
      // border-radius:10px;
     }
  }
}


</style>
